/** Accesorios ACCESORIOS COMPACTO auto-generados en muebles fregadero: COMP-BAJOENC | COMP-GRIFO */
export function isAccesorioFregaderoCatalog(
  codigoOrCatalogID?: string | number | null,
): boolean {
  if (codigoOrCatalogID == null || codigoOrCatalogID === '') return false
  const value = String(codigoOrCatalogID).toUpperCase()
  return value.startsWith('COMP-BAJOENC') || value.startsWith('COMP-GRIFO')
}

export function itemUsesAccesorioFregaderoCatalog(
  item?: {
    catalogID?: string | number | null
    codigo?: string | null
  } | null,
): boolean {
  if (item == null) return false
  return isAccesorioFregaderoCatalog(item.catalogID) || isAccesorioFregaderoCatalog(item.codigo)
}
